
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forkliftestimates",
      function () {
        return require("private-next-pages/forkliftestimates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forkliftestimates"])
      });
    }
  